import { PREGNANT_OPTION_VALUES } from '@/enums';

export const pregnantFormatter = (params: { value: number | null }) => {
  if (params.value === PREGNANT_OPTION_VALUES.YES) return 'Yes';
  if (params.value === PREGNANT_OPTION_VALUES.NO) return 'No';
  return '';
};
